import asyncComponent from '../common/utils/async-component.js';

const Members = asyncComponent(() => import('./components/members/index.js'));
const ProjectSettings = asyncComponent(() => import('./components/settings/index.js'));
const Delinquent = asyncComponent(() => import('./components/delinquent/index.js'));
const AccountSettings = asyncComponent(() => import('../auth/components/account-settings/index.js'));

export default {
  '/members': {
    components: { main: Members }
  },
  '/settings': {
    components: { main: ProjectSettings }
  },
  '/delinquent': {
    components: { main: Delinquent }
  },
  '/account-settings': {
    components: { main: AccountSettings }
  }
};
